import * as E from "fp-ts/Either";
import { fromValidate } from "../validated";
export const unknown = fromValidate(E.right);

